// Branch palette ported from the "Anela — otevřená témata" HTML template, shared
// with mind-elixir via mindElixirTheme.ts's `Theme.palette`. mind-elixir assigns
// branch colours from this array by branch index itself; everything this file used
// to also own (tier metrics, fonts, badge sizing, the manual layout's colour
// lightening) belonged to the deleted React Flow layout engine and card component
// and has no consumer left after the mind-elixir migration.
export const MIND_MAP_PALETTE = [
  "#2E7D6B",
  "#1F6FB2",
  "#6A4C93",
  "#B5651D",
  "#C2185B",
  "#7A8B2F",
  "#D08700",
  "#4C7A34",
  "#3D7B8C",
  "#77706A",
] as const;
